/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';

import { VApplication } from '../application/index';
import { GET_STORES } from '../pages/StoresList/graphql/get-stores.query';

import {STORES_DATA} from './config/stores-list-data';

const SERVICE_NAME = 'stores.service';
const { LoggerModule } = require("@vlinder-web/logger-module-react");
const log: any = LoggerModule.getInstance();

const is = require('is_js');


const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export class StoresService {
    name = SERVICE_NAME;
    private static instance: StoresService;
    private constructor() {
        this.report();
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new StoresService();
        }
        return this.instance;
    }
    async init() {}

    async getStores() {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient('graphql-gateway');
        try {
            if (client) {
                const res = await client.query({
                    query: GET_STORES,
                    variables: {
                        size: 10,
                        offset: 0,
                    },
                });
                log.info(SERVICE_NAME,'getStores: ', res);
               if(res){
                   let _data = res?.data?.findStore?.data
                   log.blue("inside getStores",_data)
                   
                   let _found = _data?.map((item: any) => {
                    return {
                        key: item?.name,
                        _id:item?.id,
                        title: item?.name,
                        subtitle1: item?.name,
                        tooltip: item?.name,
                        subtile2: '',
                        icon: {
                          imageURI: 'https://i.ibb.co/v3md5bH/retail.png',
                          imgWidth: 40,
                          imgHeight: 40,
                        }
                      
                    };
                })
                log.blue("mydata",_found)
                let result = _found;
                let _applications = {
                    pagination: {
                        nextOffset: 4,
                        totalItems: 4,
                    },
                    results: [...result],
                };
                
                return _applications;
               }
            }
         

        } catch (err:any) {
            log.error('error in get dummyQuery', err);
            // throw Error(`${err?.message}`)
            return {
                error: err?.message,
            };
        }
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, 'Module Report');
        log?.info(SERVICE_NAME, '⦿ Name: ' + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
